import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFireDatabase } from 'angularfire2/database'

@Pipe({
  name: 'filtrarCargasDeGasolinaPorOperador'
})
export class FiltrarCargasDeGasolinaPorOperadorPipe implements PipeTransform {
    constructor(public af:AngularFireDatabase){}
    transform(arregloCG:any, idOperador:any): any {
        // Arreglo de unidades que se van a mostrar
        let operadoresFiltrados:Array<any> = [];
        // Hace un loop por las unidades proporcionados para poder filtrarlos por id de operador
        if(arregloCG != undefined)
            arregloCG.forEach(viaje => {
                if(idOperador != ''){
                    if(viaje.operador == idOperador)
                        operadoresFiltrados.push(viaje)
                }else{
                    operadoresFiltrados= arregloCG
                }               
            });
    return operadoresFiltrados;
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtrar-cargas-de-gasolina-por-operador.pipe.ts